import React, { useState } from "react";
import PropTypes from "prop-types";
import DocumentEdit from "assets/svgs/DocumentEdit.svg";
import Download from "assets/svgs/Download.svg";
import { downloadFile } from "utils";

const FileAttachment = ({ attachments, title }) => {
  const [downloadStates, setDownloadStates] = useState({});

  const handleDownload = async (item, index) => {
    let url, fileName;
    if (typeof item === "string") {
      url = item;
      fileName = item.substring(item.lastIndexOf("/") + 1);
    } else if (typeof item === "object" && item.url) {
      url = item.url;
      fileName = item.name || item.url.substring(item.url.lastIndexOf("/") + 1);
    }

    if (url) {
      try {
        // Set downloading state
        setDownloadStates(prev => ({ ...prev, [index]: { downloading: true, progress: 0 } }));
        
        await downloadFile(url, fileName, (progress) => {
          setDownloadStates(prev => ({ 
            ...prev, 
            [index]: { downloading: true, progress } 
          }));
        });
        
        // Complete download
        setDownloadStates(prev => ({ ...prev, [index]: { downloading: false, progress: 100 } }));
        
        // Clear state after a short delay
        setTimeout(() => {
          setDownloadStates(prev => {
            const newState = { ...prev };
            delete newState[index];
            return newState;
          });
        }, 1000);
      } catch (error) {
        console.error("Failed to download file:", error);
        setDownloadStates(prev => {
          const newState = { ...prev };
          delete newState[index];
          return newState;
        });
      }
    }
  };

  const getFileName = (item) => {
    if (typeof item === "string") {
      return item.substring(item.lastIndexOf("/") + 1);
    } else if (typeof item === "object" && item.url) {
      return item.name || item.url.substring(item.url.lastIndexOf("/") + 1);
    }
    return "Unknown File";
  };

  if (!attachments || attachments.length === 0) return null;

  return (
    <div>
      <label className={`text-sm md:text-base text-gray3`}>{title}</label>
      {attachments.map((item, i) => {
        const downloadState = downloadStates[i];
        const isDownloading = downloadState?.downloading;
        const progress = downloadState?.progress || 0;

        return (
          <div key={i} className="mt-3">
            <div className="row-flex items-center gap-2 bg-background rounded-[4px] px-2 py-1 w-fit min-w-[200px]">
            <img src={DocumentEdit} className="h-4 w-4" alt="icon" />
              <span className="text-[10px] md:text-[12px] font-[400] text-[#6F6F7C] flex-1">
              {getFileName(item)}
            </span>
              {isDownloading ? (
                <div className="flex items-center gap-1">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
                  <span className="text-[10px] text-primary font-semibold">{progress}%</span>
                </div>
              ) : (
            <img
              src={Download}
                  className="h-4 w-4 cursor-pointer hover:opacity-70 transition-opacity"
              alt="icon"
                  onClick={() => handleDownload(item, i)}
            />
              )}
            </div>
            {isDownloading && (
              <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1 overflow-hidden">
                <div
                  className="bg-primary h-1.5 rounded-full transition-all duration-300 ease-out"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

FileAttachment.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string, // URL as a string
      PropTypes.shape({
        url: PropTypes.string.isRequired,
        name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // Name can be string or object
      }),
    ])
  ).isRequired,
  title: PropTypes.string.isRequired,
};

export default FileAttachment;
